import React from 'react';
import styled, {css} from 'styled-components';
import {FontStyles} from "../constants";

function _link(params) {
    return (
      <span className={params.className} onClick={params.onClick}>{params.children}</span>
    );
}

export const Link = styled(_link)`
    ${props => props.textStyle || FontStyles.link};
    line-height: 30px; 
`;

export const LinkLight = styled(_link)`
  line-height: 30px;
  display: block; 
  ${props => props.textStyle || FontStyles.linkLight};
  padding: 0 20px 0 20px;
  cursor: pointer;
  :hover {
    background-color: rgba(255,255,255,0.11);
    border-radius: 15px;
  }
`;